import { create } from 'zustand';
import { Chatroom } from '../../types';
import createSetter from './utils';

interface ChatroomsState {
	chatrooms: Record<string, Chatroom>;
	setChatrooms: (chatrooms: Record<string, any>) => void;
}

const useChatrooms = create<ChatroomsState>((set, get) => ({
	chatrooms: {},
	setChatrooms: createSetter<ChatroomsState>(set, get, 'chatrooms'),
}));

export default useChatrooms;
